import React, { useState } from 'react';
import { TechTabs } from '../../styles/techComponents';
import Reputacion from './Reputacion';
import CampaignStatistics from '../Statistics/CampaignStatistics';

// Unifica en una sola sección "Reputación": el ÍNDICE real (sentimiento sobre
// Chouhy) y la COBERTURA mediática + encuestas (antes "Panel de Reputación",
// que en realidad mostraba cobertura de competidores).
export default function ReputacionHub() {
  const [tab, setTab] = useState('indice');
  return (
    <div>
      <div style={{ padding: '0.6rem 0 0' }}>
        <TechTabs
          tabs={[
            { id: 'indice', label: 'Índice de reputación' },
            { id: 'cobertura', label: 'Cobertura y encuestas' },
          ]}
          active={tab}
          onChange={setTab}
        />
      </div>
      {tab === 'indice' ? <Reputacion /> : <CampaignStatistics />}
    </div>
  );
}
